import react, {useState, useEffect} from "react";
import { Image as AntdImage, Modal, Form, Input, Divider, Typography, Transfer, Tree } from "antd";

import Api from "../../api";
import "./index.scss"

const { Link } = Typography;
const { TextArea } = Input;
const PersonalSelectModal = ({open, type, cancel, teamIds, teamList, personalIds, personalList, disabledUserIds = []}) => {

    const [addForm] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [targetKeys, setTargetKeys] = useState([]);
    const [allMembers, setAllMembers] = useState([]);
    const [userType, setUserType] = useState('componey');
    const [allTeamUserList, setAllTeamUserList] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [personalCheckList, setPersonalCheckList] = useState([]);
    const [personalSelectList, setPersonalSelectList] = useState([]);

    useEffect(() => {  
        setModalOpen(open);
        if(open){
            getNotBecomeAnnotateMembers();
            getAllTeamUserList();
        }
    }, [open]);

    useEffect(() => {  
        setSelectedKeys(teamIds ? teamIds : []);
        setAllTeamUserList(teamList ? teamList : []);
        setPersonalCheckList(personalList ? personalList : []);
        setTargetKeys(personalIds ? personalIds : []);
    }, [teamIds, personalIds]);
    
    const teamSubmitForm = async () => {
        let teamList = []
        allTeamUserList.map(item => { 
            if(selectedKeys.includes(item.id)){
                teamList.push(item)
            }
        })

        let personalList = [];
        let _personalCheckList = personalCheckList ? [...personalCheckList] : [];
        let _personalSelectList = personalSelectList ? [...personalSelectList] : []
        let data = [..._personalCheckList,..._personalSelectList]
        data.map(item => { 
            if(targetKeys.includes(item.userId || item.id)){
                personalList.push(item)
            }
        })

        setSelectedKeys( []);
        setAllTeamUserList([]);
        setPersonalCheckList([]);
        setTargetKeys([]);

        cancel({
            team: selectedKeys || [],
            teamList: teamList || [],
            personal: targetKeys || [],
            personalList: personalList || []
        })
    }

    function handleCancel (type) {
        setModalOpen(false);
        cancel({},'cancel');
        setSelectedKeys( []);
        setAllTeamUserList([]);
        setPersonalCheckList([]);
        setTargetKeys([]);
    }


    const onTransferSearch = (direction,value) => {
        if(direction === "left"){
            getNotBecomeAnnotateMembers(value);
        }
    }

    const getAllTeamUserList = async () => {
        const res = await Api.Team.queryTeamList();
        if(res.code === 0){
            let data = [];
            if(type === "teamGroup"){
                res.data.map(item => { 
                    data.push({
                        ...item,
                        isLeaf: item.teamNum > 0 ? false : true,
                        // disabled: item.teamNum > 0 ? false : true,
                        name:item.teamName,
                        checkable: true
                    })
                });
            }else{
                res.data.map(item => { 
                    data.push({
                        ...item,
                        isLeaf: item.teamNum > 0 ? false : true,
                        disabled: item.teamNum > 0 ? false : true,
                        name:item.teamName,
                        checkable: false
                    })
                });
            }

            setAllTeamUserList(data);
        }
    }

    // 获取所有未成为标注成员的人员
    const getNotBecomeAnnotateMembers = async(name) => {
        try {
            const res = await Api.Common.getAllDepUser({data:{name}});
            if (res && res.code === 0) {
                const generateTree = (treeNodes = []) =>{
                    return treeNodes.map((item) => ({
                        userId: item.userId,
                        key: item.userId || item.id,
                        title: item.userName || item.name,
                        children: item.users && generateTree(item.users),
                        disabled: !item.userId,
                    }));
                }
                let data = generateTree(res.data)

                setAllMembers(data)
            }
        } catch (errInfo) {
            console.log('失败:', errInfo);
        }
    }

    const changeUserType = (type) => {
        setUserType(type)
    }

    const onTransferChange = (keys, direction, moveKeys) => {
        console.log(keys, direction, moveKeys)
        setTargetKeys(keys);
    }

    const onLoadData = ({ id, children }) => {
        return new Promise(async(resolve) => {
            if (children) {
                resolve();
                return;
            }
            const res = await Api.Team.getTeamUser({data:{
                reportTeamId: id
            }});
            resolve();
            if(res.code === 200 && res.rows){
                let data = [];
                if(type === "teamGroup"){
                    res.rows.map(item => { 
                        data.push({
                            ...item,
                            name:item.nickName,
                            id:item.userId,
                            isLeaf: true,
                            checkable: false,
                        })
                    });
                }else{
                    res.rows.map(item => { 
                        data.push({
                            ...item,
                            name:item.nickName,
                            id:item.userId,
                            isLeaf: true,
                            checkable: true,
                            disabled: disabledUserIds.includes(item.userId),
                        })
                    });
                }

                setAllTeamUserList((originList)=>updateTreeData(originList,id, data))
            }else{}
        })
    }

    const updateTreeData = (list, key, children) =>
        list.map((node) => {
            if (node.id === key) {
                return {
                    ...node,
                    children,
                };
            }
            if (node.children) {
                return {
                    ...node,
                    children: updateTreeData(node.children, key, children),
                };
            }
            return node;
        });


    const isChecked = (selectedKeys, eventKey) => selectedKeys.includes(eventKey);
    const generateTree = (treeNodes = [], checkedKeys = []) =>
    treeNodes.map(({ children, ...props }) => ({
        ...props,
        disabled: checkedKeys.includes(props.key) || disabledUserIds.includes(props.userId),
        children: generateTree(children, checkedKeys),
        checkable: props.userId ? true : false,
    }));

    const transferDataSource = [];
    function flatten(list = []) {
        list.forEach((item) => {
            console.log(item)
            if(disabledUserIds && disabledUserIds.includes(item.userId)){
                item.disabled = true;
            }
            transferDataSource.push(item);
            flatten(item.children);
        });
    }
    flatten(allMembers);

    return (
        <Modal 
            title={'选择标注人员'}
            open={modalOpen} 
            onOk={teamSubmitForm} 
            onCancel={handleCancel}
            maskClosable={false}
            destroyOnClose={true}
            confirmLoading={confirmLoading}
            wrapClassName={"selectPersonalModal"}
            width={800}
        >
            <div className="userTabs">
                <span onClick={()=>changeUserType('componey')} className={`${userType === 'componey' ? 'selectType':''}`}>公司组织</span>
                <Divider type="vertical" />
                <span onClick={()=>changeUserType('team')} className={`${userType === 'team' ? 'selectType':''}`}>自定义团队</span>
            </div>
            {userType === 'componey'&&
            <Transfer
                dataSource={transferDataSource} 
                onChange={onTransferChange}
                targetKeys={targetKeys}
                className="tree-transfer"
                render={(item) => item.title}
                showSelectAll={false}
                showSearch={true}
                onSearch={onTransferSearch}
            >
                {({ direction, onItemSelect, selectedKeys }) => {
                    if (direction === 'left') {
                        const checkedKeys = [...selectedKeys, ...targetKeys];
                        return (
                            <Tree
                                blockNode
                                checkable
                                checkStrictly
                                checkedKeys={checkedKeys}
                                treeData={generateTree(allMembers, targetKeys)}
                                onCheck={(_, { node: { key }, checkedNodes }) => {
                                    console.log('node', checkedNodes);
                                    onItemSelect(key, !isChecked(checkedKeys, key));
                                    setPersonalCheckList(checkedNodes)
                                }}
                                onSelect={(_, { node: { key }, selectedNodes }) => {
                                    console.log('node', selectedNodes);
                                    onItemSelect(key, !isChecked(checkedKeys, key));

                                    if(selectedNodes[0].checkable){
                                        let newList = [...personalSelectList,...selectedNodes]
                                        setPersonalSelectList(newList)
                                    }
                                    
                                }}
                            />
                        );
                    }
                }}
            </Transfer>}

            {userType === 'team'&&<div>
                <Tree
                    checkable
                    fieldNames={{ title: 'name', key: 'id'}}
                    checkedKeys={selectedKeys}
                    treeData={allTeamUserList}
                    loadData={onLoadData}
                    onCheck={(_checkedKeys) => {
                        console.log(_checkedKeys)
                        setSelectedKeys(_checkedKeys)
                    }}
                    onSelect={(_selectedKeys, node) => {
                        if(selectedKeys.includes(node.node.key)){
                            let newSelectedKeys = selectedKeys.filter(item=>item!==node.node.key)
                            setSelectedKeys(newSelectedKeys)
                        }else{
                            setSelectedKeys([...selectedKeys,..._selectedKeys])
                        }
                    }}
                />
            </div>}


            {/* {userType === 'team'&& type === "teamGroup" &&<div>
                <Tree
                    checkable
                    fieldNames={{ title: 'name', key: 'id'}}
                    checkedKeys={selectedKeys}
                    treeData={allTeamUserList}
                    // loadData={onLoadData}
                    onCheck={(_checkedKeys) => {
                        console.log(_checkedKeys)
                        setSelectedKeys(_checkedKeys)
                    }}
                    onSelect={(_selectedKeys, node) => {
                        if(selectedKeys.includes(node.node.key)){
                            let newSelectedKeys = selectedKeys.filter(item=>item!==node.node.key)
                            setSelectedKeys(newSelectedKeys)
                        }else{
                            setSelectedKeys([...selectedKeys,..._selectedKeys])
                        }
                    }}
                />
            </div>} */}
            
        </Modal>
    )
}

export default PersonalSelectModal;